const headers = [{
    text: "Descrição / Especificação",
    align: "left",
    sortable: true,
    value: "description"
  },

  {
    text: "Unidade",
    align: "center",
    value: "unity"
  },
  {
    text: "Quantidade",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  },
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
  {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  },
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]

class Headers {
  static getHeaders() {
    return headers
  }
}
export default Headers;



// WEBPACK FOOTER //
// ./src/data/headers/AttachmentHeaders.js